import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=db2615f2&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"
import style0 from "./ConfirmOrder.vue?vue&type=style&index=0&id=db2615f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2615f2",
  null
  
)

export default component.exports